import { render, staticRenderFns } from "./SchoolShow.vue?vue&type=template&id=27d325e0&"
import script from "./SchoolShow.vue?vue&type=script&lang=js&"
export * from "./SchoolShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports